// events for EventEmitter
export const Events = {
  CHANGES: 'changes',
  SWAP_MATCH: 'swap-match',
};

// player types
export const PlayerType = {
  REAL: 'real',
  BOT: 'bot',
};

export const PlayerTurn = {
  player1: 0,
  player2: 1,
};

// for calculating score
export const ScoreConfig = {
  'green-gem': 12,
  'red-gem': 10,
  'purple-gem': 20,
  'gold-gem': 5,
  'blue-gem': 15,
};

export const POWER_UPS = {
  DOUBLE_POINTS: 'doublePoints',
  FREEZE: 'freeze',
  RESHUFFLE: 'reShuffle',
  SWAP_TWO: 'swapTwo',
  BURST_FOUR: 'burstFour',
  POTENTIAL_MOVES: 'potentialMoves',
};

export const POWERUPS_STATUS = {
  USED: 0,
  NOT_USED: 1,
  SELECTED: 2,
};
